// API Configuration
export const API_BASE_URL = 'https://fuelwise-1der.onrender.com/api'; // this is the production URL
//export const API_BASE_URL = 'https://fuelwise-api-staging.onrender.com/api'; // this is the staging URL


